import { Link } from 'react-router-dom';

/** Vista cuando no hay conversación seleccionada en /app/conversations */
export function ConversationsIndexPlaceholder() {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748b',
        fontSize: 15,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <div>
        <p style={{ margin: 0 }}>Elegí una conversación en la barra lateral o creá una nueva en <strong>Testchat</strong>.</p>
        <p style={{ margin: '12px 0 0', fontSize: 13 }}>
          Los canales <strong>Messenger</strong> e <strong>Instagram</strong> aparecen cuando lleguen mensajes desde Meta.
        </p>
        <p style={{ margin: '16px 0 0', fontSize: 13 }}>
          <Link to="/app/integrations" style={{ color: '#7c3aed' }}>
            Configurar canales
          </Link>
        </p>
      </div>
    </div>
  );
}
